import React, { useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { BrandChart_SAL2100_R01 } from "./Chart/BrandChart_SAL2100_R01";
import { ItemGroupChart_SAL2100_R01 } from "./Chart/ItemGroupChart_SAL2100_R01";
import { SalesChart_SAL2100_R01 } from "./Chart/SalesChart_SAL2100_R01";
import { Content_SAL2100_R01 } from "./Content_SAL2100_R01";
import { SearchSection_SAL2100_R01 } from "./SearchSection_SAL2100_R01";
import { useSAL2100_R01Store } from "./Store_SAL2100_R01";
import { BrandTable_SAL2100_R01 } from "./Table/BrandTable_SAL2100_R01";
import { ItemGroupTable_SAL2100_R01 } from "./Table/ItemGroupTable_SAL2100_R01";
import { SalesTable_SAL2100_R01 } from "./Table/SalesTable_SAL2100_R01";

const SALES_RESIZER = {
	code: "SAL2100_R01_sales",
	type: "width",
	storageKey: "SAL2100_R01-sales-split-width",
	min: 20,
	max: 60,
	default: 34,
} as const;

const ITEM_GROUP_RESIZER = {
	code: "SAL2100_R01_itemGroup",
	type: "width",
	storageKey: "SAL2100_R01-itemGroup-split-width",
	min: 20,
	max: 80,
	default: 50,
} as const;

export const Container_SAL2100_R01 = () => {
	const {
		SAL2100_R01MonthlyList,
		SAL2100_R01ItemGroupList,
		SAL2100_R01BrandList,
		initData,
	} = useSAL2100_R01Store();
	const { setMessage } = useUiuxStore();
	const analysisContainerRef = useRef<HTMLDivElement>(null);
	const rightContainerRef = useRef<HTMLDivElement>(null);
	const brandContainerRef = useRef<HTMLDivElement>(null);
	const isSalesResizing = useRef(false);
	const isItemGroupResizing = useRef(false);
	const {
		splitValue: salesSplitValue,
		handleMouseDown: handleSalesMouseDown,
	} = useMouseContent({
		resizer: SALES_RESIZER,
		isResizing: isSalesResizing,
		containerRef: analysisContainerRef,
		infoRef: rightContainerRef,
	});
	const {
		splitValue: itemGroupSplitValue,
		handleMouseDown: handleItemGroupMouseDown,
	} = useMouseContent({
		resizer: ITEM_GROUP_RESIZER,
		isResizing: isItemGroupResizing,
		containerRef: rightContainerRef,
		infoRef: brandContainerRef,
	});
	const { fetchData, handleExcelClick } = Content_SAL2100_R01(setMessage);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={undefined}
				onDeleteClick={undefined}
				onSaveClick={undefined}
				onPrintClick={undefined}
				onExcelClick={handleExcelClick}
				onInitClick={initData}
			/>
			<SearchSection_SAL2100_R01 />
			<div
				className="flex flex-1 gap-[4px] overflow-auto p-[12px] min-h-0"
				ref={analysisContainerRef}
			>
				<section className="flex h-full min-w-0 flex-col gap-3 overflow-auto px-1"style={{ width: `${salesSplitValue}%` }}>

					<h2 className="text-[22px] font-medium text-gray-900">월별 매출 조회</h2>
					<SalesChart_SAL2100_R01 data={SAL2100_R01MonthlyList} />
					<SalesTable_SAL2100_R01 data={SAL2100_R01MonthlyList} />
				</section>

				<div
					className="w-[6px] shrink-0 cursor-col-resize bg-gray-100 hover:bg-gray-300"
					onMouseDown={(event: React.MouseEvent<HTMLDivElement>) =>
						handleSalesMouseDown("LR", event.nativeEvent)}
					data-comment="월별 매출 영역 리사이저"
				/>

				<div
					className="flex h-full min-w-0 gap-[4px]"
					style={{ width: `${100 - salesSplitValue}%` }}
					ref={rightContainerRef}
				>
					<section className="flex h-full min-w-0 flex-col gap-3 overflow-auto px-1" style={{ width: `${itemGroupSplitValue}%` }} >

						<h2 className="text-[22px] font-medium text-gray-900">품목그룹별 매출조회</h2>
						<ItemGroupChart_SAL2100_R01 data={SAL2100_R01ItemGroupList} />
						<ItemGroupTable_SAL2100_R01 data={SAL2100_R01ItemGroupList} />
					</section>

					<div
						className="w-[6px] shrink-0 cursor-col-resize bg-gray-100 hover:bg-gray-300"
						onMouseDown={(event: React.MouseEvent<HTMLDivElement>) =>
							handleItemGroupMouseDown("LR", event.nativeEvent)}
						data-comment="품목그룹 영역 리사이저"
					/>

					<section className="flex h-full min-w-0 flex-col gap-3 overflow-auto px-1" style={{ width: `${100 - itemGroupSplitValue}%` }} ref={brandContainerRef} >

						<h2 className="text-[22px] font-medium text-gray-900">브랜드별 매출실적</h2>
						<BrandChart_SAL2100_R01 data={SAL2100_R01BrandList} />
						<BrandTable_SAL2100_R01 data={SAL2100_R01BrandList} />
					</section>
				</div>
			</div>
			<Message />
		</div>
	);
};
